import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';
import { defaultTheme } from "./defaultTheme";
export var ThemeProvider = function (props) {
    return React.createElement(MuiThemeProvider, { theme: defaultTheme, children: props.children });
};
